import { render, staticRenderFns } from "./memberStatus.vue?vue&type=template&id=31958414&scoped=true"
import script from "./memberStatus.vue?vue&type=script&lang=js"
export * from "./memberStatus.vue?vue&type=script&lang=js"
import style0 from "./memberStatus.vue?vue&type=style&index=0&id=31958414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31958414",
  null
  
)

export default component.exports